"use client"

import {
    OctagonXIcon,
    TriangleAlertIcon,
} from "lucide-react"
import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner";

/**
 * EMS ERP Standard Toaster — Strict Two-Color Exception Channel ONLY:
 * - Yellow Warning (`toast.warning` — high-contrast slate-950 text on amber-400/500)
 * - Red Error (`toast.error` — white text on rose-600)
 * Routine processing & success notifications are routed silently to <HeaderSyncIndicator />.
 */
const Toaster = ({
    ...props
}: React.ComponentProps<typeof Sonner>) => {
    const { theme = "system" } = useTheme()

    return (
        <Sonner
            theme={theme as "light" | "dark" | "system"}
            className="toaster group pointer-events-auto [&_[data-sonner-toast]]:pointer-events-auto [&_[data-close-button]]:pointer-events-auto"
            closeButton
            toastOptions={{
                classNames: {
                    toast: "pointer-events-auto shadow-xl font-semibold",
                    closeButton: "pointer-events-auto cursor-pointer",
                    warning:
                        "pointer-events-auto !bg-amber-400 !text-slate-950 !border-amber-600 font-semibold shadow-xl [&_[data-description]]:!text-slate-900 [&_[data-close-button]]:!bg-amber-500 [&_[data-close-button]]:!text-slate-950 [&_[data-close-button]]:!border-amber-700",
                    error:
                        "pointer-events-auto !bg-rose-600 !text-white !border-rose-700 font-semibold shadow-xl [&_[data-description]]:!text-rose-50 [&_[data-close-button]]:!bg-rose-700 [&_[data-close-button]]:!text-white [&_[data-close-button]]:!border-rose-800",
                },
            }}
            icons={{
                warning: <TriangleAlertIcon className="size-4 text-slate-950 shrink-0" />,
                error: <OctagonXIcon className="size-4 text-white shrink-0" />,
            }}
            style={
                {
                    "--normal-bg": "var(--popover)",
                    "--normal-text": "var(--popover-foreground)",
                    "--normal-border": "var(--border)",
                    "--border-radius": "var(--radius)",
                    zIndex: 99999,
                    pointerEvents: "auto",
                } as React.CSSProperties
            }
            {...props}
        />
    );
}

export { Toaster }
